var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomRegexModalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6183_6118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#0A8BC7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6183_6118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4748 22C10.0081 22 9.57064 21.9 9.1623 21.7C8.75397 21.5 8.40814 21.2167 8.1248 20.85L2.6748 13.925L3.1498 13.425C3.48314 13.075 3.88314 12.8667 4.3498 12.8C4.81647 12.7333 5.2498 12.825 5.6498 13.075L7.4998 14.2V6C7.4998 5.71667 7.59564 5.47917 7.7873 5.2875C7.97897 5.09583 8.21647 5 8.4998 5C8.78314 5 9.0248 5.09583 9.2248 5.2875C9.4248 5.47917 9.5248 5.71667 9.5248 6V17.8L7.0998 16.3L9.6998 19.625C9.7998 19.7417 9.91647 19.8333 10.0498 19.9C10.1831 19.9667 10.3248 20 10.4748 20H15.9998C16.5498 20 17.0206 19.8042 17.4123 19.4125C17.804 19.0208 17.9998 18.55 17.9998 18V14C17.9998 13.7167 17.904 13.4792 17.7123 13.2875C17.5206 13.0958 17.2831 13 16.9998 13H11.5248V11H16.9998C17.8331 11 18.5415 11.2917 19.1248 11.875C19.7081 12.4583 19.9998 13.1667 19.9998 14V18C19.9998 19.1 19.6081 20.0417 18.8248 20.825C18.0415 21.6083 17.0998 22 15.9998 22H10.4748ZM4.1748 8.5C3.95814 8.13333 3.79147 7.7375 3.6748 7.3125C3.55814 6.8875 3.4998 6.45 3.4998 6C3.4998 4.61667 3.9873 3.4375 4.9623 2.4625C5.9373 1.4875 7.11647 1 8.4998 1C9.88314 1 11.0623 1.4875 12.0373 2.4625C13.0123 3.4375 13.4998 4.61667 13.4998 6C13.4998 6.45 13.4415 6.8875 13.3248 7.3125C13.2081 7.7375 13.0415 8.13333 12.8248 8.5L11.0998 7.5C11.2331 7.26667 11.3331 7.02917 11.3998 6.7875C11.4665 6.54583 11.4998 6.28333 11.4998 6C11.4998 5.16667 11.2081 4.45833 10.6248 3.875C10.0415 3.29167 9.33314 3 8.4998 3C7.66647 3 6.95814 3.29167 6.3748 3.875C5.79147 4.45833 5.4998 5.16667 5.4998 6C5.4998 6.28333 5.53314 6.54583 5.5998 6.7875C5.66647 7.02917 5.76647 7.26667 5.8998 7.5L4.1748 8.5Z",
    fill: "#0A8BC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomRegexModalIcon);
export default __webpack_public_path__ + "static/media/custom_regex_modal_icon.803296c30a3e0ff4292e94d96419e2c8.svg";
export { ForwardRef as ReactComponent };